import { reactive } from 'vue';

const data = reactive({
    message: '',
    type: 'info',
    active: false,
    timeout: null,
    timeoutId: null,
});

const useNotification = () => {
    const StopTimer = () => {
        clearTimeout(data.timeoutId);
        data.timeoutId = null;
    };

    const StartTimer = () => {
        if (!data.timeoutId && data.timeout) {
            data.timeoutId = setTimeout(toggleNotification, data.timeout * 1000);
        }
    };

    const showNotification = (newMessage, type = 'info', timeout = null) => {
        data.message = newMessage;
        data.type = type;
        data.timeout = timeout;
        StartTimer();
        data.active = true;
    };

    const hideNotification = () => {
        StopTimer();
        data.active = false;
    };

    const toggleNotification = () => {
        (data.active) ? StopTimer(): StartTimer();
        data.active = !data.active;
    };

    return {
        notification: data,
        showNotification,
        hideNotification,
        toggleNotification
    };
};

export default useNotification;
